import { createClient } from '@supabase/supabase-js';

const supabaseUrl = process.env.REACT_APP_SUPABASE_URL || 'YOUR_SUPABASE_URL';
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY || 'YOUR_SUPABASE_ANON_KEY';

export const supabase = createClient(supabaseUrl, supabaseAnonKey);

// Game Sessions API
export const gameSessionsAPI = {
  // Create a new game session
  async create(sessionData) {
    const { data, error } = await supabase
      .from('game_sessions')
      .insert([{
        game_type: sessionData.game_type,
        score: sessionData.score,
        accuracy: sessionData.accuracy,
        duration: sessionData.duration,
        player_name: sessionData.player_name || 'Anonymous',
        created_at: new Date().toISOString()
      }])
      .select();
    
    if (error) throw error;
    return data[0];
  },

  // Get all sessions with limit
  async getAll(limit = 50) {
    const { data, error } = await supabase
      .from('game_sessions')
      .select('*')
      .order('created_at', { ascending: false })
      .limit(limit);
    
    if (error) throw error;
    return data;
  },

  // Get leaderboard
  async getLeaderboard(gameType = null, limit = 10) {
    let query = supabase
      .from('game_sessions')
      .select('*')
      .order('score', { ascending: false })
      .limit(limit);
    
    if (gameType) {
      query = query.eq('game_type', gameType);
    }
    
    const { data, error } = await query;
    
    if (error) throw error;
    
    // Add rank to each entry
    return data.map((entry, index) => ({
      ...entry,
      rank: index + 1
    }));
  },

  // Get stats
  async getStats() {
    const { data, error } = await supabase
      .from('game_sessions')
      .select('game_type, score, accuracy');
    
    if (error) throw error;
    
    const totalSessions = data.length;
    
    // Calculate stats by game type
    const gameStats = data.reduce((acc, session) => {
      if (!acc[session.game_type]) {
        acc[session.game_type] = {
          _id: session.game_type,
          total_plays: 0,
          avg_score: 0,
          avg_accuracy: 0,
          scores: [],
          accuracies: []
        };
      }
      
      acc[session.game_type].total_plays++;
      acc[session.game_type].scores.push(session.score);
      acc[session.game_type].accuracies.push(session.accuracy);
      
      return acc;
    }, {});
    
    // Calculate averages
    Object.keys(gameStats).forEach(gameType => {
      const stats = gameStats[gameType];
      stats.avg_score = stats.scores.reduce((a, b) => a + b, 0) / stats.scores.length;
      stats.avg_accuracy = stats.accuracies.reduce((a, b) => a + b, 0) / stats.accuracies.length;
      delete stats.scores;
      delete stats.accuracies;
    });
    
    return {
      total_sessions: totalSessions,
      game_stats: Object.values(gameStats)
    };
  }
};
